if (!window.bestsellerGalleryInitialized) {
  window.bestsellerGalleryInitialized = true;
  // Keep the complete price on one line, scaling all three parts by the same amount.
  const fitPrice = (price) => {
    const line = price.querySelector('.bestseller-card__price-line');
    if (!line) return;
    line.style.removeProperty('font-size');
    if (window.innerWidth > 1199 || !price.clientWidth) return;
    const width = line.getBoundingClientRect().width;
    if (width > price.clientWidth) {
      line.style.fontSize = `${parseFloat(getComputedStyle(price).fontSize) * price.clientWidth / width}px`;
    }
  };
  const priceObserver = new ResizeObserver(entries => entries.forEach(entry => fitPrice(entry.target)));
  const observedPrices = new WeakSet();
  const observePrices = (root) => {
    const prices = [...root.querySelectorAll('.bestseller-card__price')];
    if (root.matches?.('.bestseller-card__price')) prices.push(root);
    prices.forEach(price => {
      if (observedPrices.has(price)) return;
      observedPrices.add(price);
      priceObserver.observe(price);
      fitPrice(price);
    });
  };
  observePrices(document);
  document.fonts.ready.then(() => document.querySelectorAll('.bestseller-card__price').forEach(fitPrice));
  new MutationObserver(records => records.forEach(record => {
    record.removedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      const prices = [...node.querySelectorAll('.bestseller-card__price')];
      if (node.matches('.bestseller-card__price')) prices.push(node);
      prices.forEach(price => { priceObserver.unobserve(price); observedPrices.delete(price); });
    });
    record.addedNodes.forEach(node => { if (node.nodeType === 1) observePrices(node); });
  })).observe(document.body, { childList: true, subtree: true });
  const submitCard = (event) => {
    const form = event.type === 'submit'
      ? event.target.closest('.bestseller-card__form form')
      : event.target.closest('.bestseller-card__form button[type="submit"]')?.form;
    const productForm = form?.closest('product-form');
    if (!productForm || typeof productForm.onSubmitHandler !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.querySelectorAll('.adoric-input, input[name="properties[__adoric]"]').forEach((input) => input.remove());
    productForm.onSubmitHandler(event);
  };
  window.addEventListener('click', submitCard, true);
  window.addEventListener('submit', submitCard, true);
  const changeImage = (gallery, direction, startIndex) => {
  const images = [...gallery.querySelectorAll('.bestseller-card__image')];
  if (images.length < 2) return;
  const current = startIndex ?? images.findIndex((image) => image.classList.contains('is-active'));
  const next = (Math.max(current, 0) + Math.sign(direction) + images.length) % images.length;
  images.forEach((image, index) => {
    image.classList.toggle('is-active', index === next);
    image.setAttribute('aria-hidden', String(index !== next));
    image.inert = index !== next;
    if (image.matches('a')) image.tabIndex = index === next ? 0 : -1;
    if (index !== next) {
      image.querySelectorAll('video').forEach(video => window.galleryVideoPlayback.suspend(video));
      if (image.querySelector('iframe')) {
        image.querySelectorAll('iframe').forEach(frame => frame.remove());
        image.removeAttribute('loaded');
      }
    }
  });
  images[next].querySelectorAll('video').forEach(video => window.galleryVideoPlayback.resume(video));
  const counter = gallery.querySelector('[data-gallery-current]');
  if (counter) counter.textContent = String(next + 1);
  };
  document.addEventListener('click', (event) => {
    const swipeSurface = event.target.closest('.bestseller-card__video-swipe');
    if (swipeSurface) {
      event.preventDefault();
      const gallery = swipeSurface.closest('[data-product-gallery]');
      if (performance.now() < (gallery.suppressVideoClickUntil || 0)) return;
      const video = swipeSurface.parentElement.querySelector('video');
      if (video) {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      }
      return;
    }
    const button = event.target.closest('[data-product-gallery] [data-direction]');
    if (button) {
      const gallery = button.closest('[data-product-gallery]');
      const pending = settling.get(gallery);
      if (pending) { clearTimeout(pending.origin.timer); pending.finish(); }
      changeImage(gallery, Number(button.dataset.direction));
    }
  });
  let gesture;
  const settling = new WeakMap();
  const renderDrag = (origin, dx, animate = false) => {
    dx = Math.max(-origin.width, Math.min(origin.width, dx));
    const direction = dx < 0 ? 1 : -1;
    const neighbor = (origin.current + direction + origin.images.length) % origin.images.length;
    const pair = [origin.current, neighbor];
    origin.visible?.filter(index => !pair.includes(index)).forEach(index => {
      origin.images[index].style.opacity = '0';
    });
    origin.visible = pair;
    pair.forEach(index => {
      const image = origin.images[index];
      image.style.transition = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'transform .3s ease' : 'none';
      image.style.opacity = index === origin.current || index === neighbor ? '1' : '0';
      const offset = index === origin.current ? dx : dx + direction * origin.width;
      image.style.transform = `translate3d(${offset}px, 0, 0)`;
    });
  };
  const settle = (origin, commit) => {
    if (!origin.dragging && !origin.visible) return;
    const direction = commit && origin.direction ? origin.direction : origin.dx < 0 ? 1 : -1;
    clearTimeout(origin.timer);
    // Keep the incoming image on the same side when snapping back to zero.
    renderDrag(origin, commit ? -direction * origin.width : direction === 1 ? -.001 : .001, true);
    const finish = () => {
      origin.images.forEach(image => { image.style.transition = 'none'; });
      if (commit) changeImage(origin.gallery, direction, origin.current);
      origin.images.forEach(image => {
        image.style.removeProperty('opacity');
        image.style.removeProperty('transform');
      });
      // Commit the resting layout before restoring the desktop fade transition.
      void origin.gallery.offsetWidth;
      origin.images.forEach(image => image.style.removeProperty('transition'));
      settling.delete(origin.gallery);
    };
    settling.set(origin.gallery, { origin, finish, target: commit ? (origin.current + direction + origin.images.length) % origin.images.length : origin.current });
    origin.timer = setTimeout(finish, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 310);
  };
  document.addEventListener('touchstart', (event) => {
    if (gesture) settle(gesture, false);
    gesture = null;
    if (event.touches.length !== 1) return;
    const gallery = event.target.closest('[data-product-gallery]');
    if (!gallery || gallery.querySelectorAll('.bestseller-card__image').length < 2) return;
    gallery.suppressVideoClickUntil = 0;
    const video = event.target.closest('video');
    if (event.target.closest('iframe') || video?.controls && event.touches[0].clientY > video.getBoundingClientRect().bottom - 44) return;
    let baseX = 0;
    const pending = settling.get(gallery);
    if (pending) {
      baseX = new DOMMatrixReadOnly(getComputedStyle(pending.origin.images[pending.target]).transform).m41;
      clearTimeout(pending.origin.timer);
      pending.finish();
    }
    const touch = event.touches[0];
    const images = [...gallery.querySelectorAll('.bestseller-card__image')];
    gesture = { gallery, images, current: Math.max(0, images.findIndex(image => image.classList.contains('is-active'))), width: gallery.clientWidth, x: touch.clientX, y: touch.clientY, id: touch.identifier, dx: baseX, baseX, time: performance.now() };
    [-1, 1].forEach(step => {
      const image = images[(gesture.current + step + images.length) % images.length];
      image.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.decode?.().catch(() => {}); });
    });
    if (baseX) renderDrag(gesture, baseX);
  }, { passive: true });
  document.addEventListener('touchmove', (event) => {
    if (!gesture) return;
    if (event.touches.length !== 1) { settle(gesture, false); gesture = null; return; }
    const touch = [...event.touches].find(item => item.identifier === gesture.id);
    if (!touch) return;
    const dx = touch.clientX - gesture.x;
    const dy = touch.clientY - gesture.y;
    if (!gesture.dragging) {
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
      if (Math.abs(dx) <= Math.abs(dy) * 1.3) { settle(gesture, false); gesture = null; return; }
      gesture.dragging = true;
    }
    if (event.cancelable) event.preventDefault();
    gesture.dx = Math.max(-gesture.width, Math.min(gesture.width, gesture.baseX + dx));
    gesture.movement = dx;
    renderDrag(gesture, gesture.dx);
  }, { passive: false });
  document.addEventListener('touchend', (event) => {
    const origin = gesture;
    gesture = null;
    if (!origin || !origin.gallery.isConnected) return;
    const touch = [...event.changedTouches].find(item => item.identifier === origin.id);
    if (touch) {
      const dx = touch.clientX - origin.x, dy = touch.clientY - origin.y;
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        origin.dragging = true;
        origin.movement = dx;
        origin.dx = Math.max(-origin.width, Math.min(origin.width, origin.baseX + dx));
        renderDrag(origin, origin.dx);
        void origin.gallery.offsetWidth;
      }
    }
    if (!origin.dragging) { settle(origin, false); return; }
    // A deliberate swipe must not follow the product image link.
    origin.gallery.suppressVideoClickUntil = performance.now() + 450;
    if (event.cancelable) event.preventDefault();
    const movement = origin.movement || 0;
    origin.direction = movement < 0 ? 1 : -1;
    settle(origin, Math.abs(movement) >= Math.max(35, origin.width * .2) || (Math.abs(movement) > 25 && Math.abs(movement) / (performance.now() - origin.time) > .5));
  }, { passive: false });
  document.addEventListener('touchcancel', () => { if (gesture) settle(gesture, false); gesture = null; }, { passive: true });
  window.addEventListener('resize', () => { if (gesture) settle(gesture, false); gesture = null; });
}
